// Chain configurations - now reads from environment variables
export const CHAINS = {
  RONIN: {
    id: parseInt(process.env.REACT_APP_RONIN_CHAIN_ID) || 2020,
    name: process.env.REACT_APP_RONIN_CHAIN_NAME || 'Ronin',
    symbol: 'RON',
    rpcUrl: process.env.REACT_APP_RONIN_RPC_URL || 'https://api.roninchain.com/rpc',
    explorerUrl: process.env.REACT_APP_RONIN_EXPLORER_URL || 'https://explorer.roninchain.com',
    iconUrl: '/images/ronin-icon.svg',
    color: '#0ea5e9',
    nativeCurrency: {
      name: 'RON',
      symbol: 'RON',
      decimals: 18
    }
  },
  BNB: {
    id: parseInt(process.env.REACT_APP_BNB_CHAIN_ID) || 56,
    name: process.env.REACT_APP_BNB_CHAIN_NAME || 'BNB Smart Chain',
    symbol: 'BNB',
    rpcUrl: process.env.REACT_APP_BNB_RPC_URL || 'https://bsc-dataseed1.binance.org/',
    explorerUrl: process.env.REACT_APP_BNB_EXPLORER_URL || 'https://bscscan.com',
    iconUrl: '/images/bnb-icon.svg',
    color: '#f3ba2f',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  }
};

// Contract addresses (these will be filled after deployment)
export const CONTRACTS = {
  RONIN: {
    PFVS_TOKEN: process.env.REACT_APP_RONIN_PFVS_ADDRESS || '0x0000000000000000000000000000000000000000',
    BRIDGE: process.env.REACT_APP_RONIN_BRIDGE_ADDRESS || '0x0000000000000000000000000000000000000000'
  },
  BNB: {
    PFVS_TOKEN: process.env.REACT_APP_BNB_PFVS_ADDRESS || '0x0000000000000000000000000000000000000000',
    BRIDGE: process.env.REACT_APP_BNB_BRIDGE_ADDRESS || '0x0000000000000000000000000000000000000000'
  }
};

// Bridge configuration
export const BRIDGE_CONFIG = {
  MIN_AMOUNT: '10', // 0.01 PFVS
  MAX_AMOUNT: '1000000000', // 1B PFVS
  DECIMALS: 18,
  CONFIRMATION_BLOCKS: {
    RONIN: 12,
    BNB: 15
  },
};

// Transaction statuses
export const TX_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  EXPIRED: 'expired'
};

// Toast configuration
export const TOAST_CONFIG = {
  duration: 5000,
  position: 'top-right',
  style: {
    borderRadius: '12px',
    background: '#1f2937',
    color: '#f3f4f6',
    fontSize: '14px',
    fontWeight: '500'
  }
};

// Wallet types
export const WALLET_TYPES = {
  METAMASK: 'metamask',
  RONIN: 'ronin',
  WALLET_CONNECT: 'walletconnect'
};

// Local storage keys
export const STORAGE_KEYS = {
  RECENT_TRANSACTIONS: 'pfvs_bridge_recent_tx',
  WALLET_CONNECTION: 'pfvs_bridge_wallet',
  THEME_PREFERENCE: 'pfvs_bridge_theme'
};

// Event types for transaction tracking
export const EVENT_TYPES = {
  BRIDGE_REQUEST_CREATED: 'BridgeRequestCreated',
  BRIDGE_RECEIVE_EXECUTED: 'BridgeReceiveExecuted',
  BRIDGE_RECEIVE_APPROVED: 'BridgeReceiveApproved'
};

// Error messages
export const ERROR_MESSAGES = {
  WALLET_NOT_CONNECTED: 'Please connect your wallet',
  INSUFFICIENT_BALANCE: 'Insufficient token balance',
  INSUFFICIENT_GAS: 'Insufficient gas for transaction',
  AMOUNT_TOO_LOW: 'Amount is below minimum threshold',
  AMOUNT_TOO_HIGH: 'Amount exceeds maximum threshold',
  NETWORK_ERROR: 'Network error, please try again',
  TRANSACTION_FAILED: 'Transaction failed',
  INVALID_AMOUNT: 'Please enter a valid amount',
  BRIDGE_PAUSED: 'Bridge is currently paused',
  DAILY_LIMIT_EXCEEDED: 'Daily limit exceeded'
};

// Success messages
export const SUCCESS_MESSAGES = {
  WALLET_CONNECTED: 'Wallet connected successfully',
  TRANSACTION_SUBMITTED: 'Transaction submitted successfully',
  BRIDGE_COMPLETED: 'Bridge transaction completed',
  APPROVAL_SUCCESS: 'Token approval successful'
};

// Refresh intervals (in milliseconds)
export const REFRESH_INTERVALS = {
  BALANCE: 10000, // 10 seconds
  TRANSACTION_STATUS: 10000, // 10 seconds
  BRIDGE_STATUS: 60000, // 1 minute
  PRICE_DATA: 300000 // 5 minutes
};

// Gas limits for different operations
export const GAS_LIMITS = {
  APPROVE: '100000',
  LOCK: '200000',
  RELEASE: '150000',
  BURN: '100000',
  MINT: '150000'
};

// Default slippage tolerance
export const DEFAULT_SLIPPAGE = 0.5; // 0.5%

// Animation durations
export const ANIMATION_DURATIONS = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500
};

export default {
  CHAINS,
  CONTRACTS,
  BRIDGE_CONFIG,
  TX_STATUS,
  TOAST_CONFIG,
  WALLET_TYPES,
  STORAGE_KEYS,
  EVENT_TYPES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  REFRESH_INTERVALS,
  GAS_LIMITS,
  DEFAULT_SLIPPAGE,
  ANIMATION_DURATIONS
}; 